import { ArrowRightCircle } from "react-feather";
import { SCROLLING_UX_DATA } from "../../../../../Data/UiKit/Modal";
import { UXDesigners } from "../../../../../Constant";
import { H6, P } from "../../../../../AbstractElements";

export const UXDesigner = () => {
  return (
    <>
      <H6>{UXDesigners}</H6>
      <div className="d-flex mt-3">
        <div className="flex-shrink-0"><ArrowRightCircle className="svg-modal" /></div>
        <div className="flex-grow-1 ms-2">
          <P>User research, persona creation, building wireframes and interactive prototypes, and testing ideas are among the common tasks of a UX designer. These duties can differ greatly between organizations.</P>
        </div>
      </div>
      {SCROLLING_UX_DATA.map((item, index) => (
        <div className="d-flex mt-3" key={index}>
          <div className="flex-shrink-0"><ArrowRightCircle className="svg-modal" /></div>
          <div className="flex-grow-1 ms-2">
            <P>{item}</P>
            </div>
        </div>
      ))}
    </>
  );
};
